var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJwacKRnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-480 -790) translate(480 790)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    fill: "#32239B",
    stroke: "#FFF",
    strokeLinejoin: "square",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M20 12.37v8.156C20 23.536 17.75 26 15 26s-5-2.463-5-5.474V5.474C10 2.464 12.25 0 15 0s5 2.463 5 5.474v6.896z",
    transform: "translate(-480 -790) translate(480 790) translate(14.818 12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M25 17v4.101C25 27.096 20.5 32 15 32S5 27.096 5 21.101V17M15.5 37L15.5 33",
    transform: "translate(-480 -790) translate(480 790) translate(14.818 12.5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EE3D85",
    strokeWidth: 3,
    d: "M0.682 4L28.682 32",
    transform: "translate(-480 -790) translate(480 790) translate(14.818 12.5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJwacKRnn);
export default __webpack_public_path__ + "static/media/jwacKRnn.b8c53d5ce3e8d4c98726e1888633ce11.svg";
export { ForwardRef as ReactComponent };